/** Calm ease — hovers, S3 enters, questionnaire, chat beats. */
export const EASE_CALM = [0.4, 0, 0.2, 1] as const;

/** Hero intro — fast start, slow settle (not classic ease-in-out). */
export const EASE_INTRO = [0.22, 1, 0.36, 1] as const;

export function clamp(value: number, min = 0, max = 1) {
	return Math.min(max, Math.max(min, value));
}

export function lerp(from: number, to: number, progress: number) {
	return from + (to - from) * progress;
}

export function easeInOut(progress: number) {
	const boundedProgress = clamp(progress);
	return boundedProgress * boundedProgress * (3 - 2 * boundedProgress);
}
